import React from 'react'

function GapMaintainer({backroundColorNeeded}) {
  return (
    <div>
      <div style={{margin:"140px 0",background:backroundColorNeeded}}>

      </div>
    </div>
  )
}

export default GapMaintainer
